export default __webpack_public_path__ + "static/media/profile.703f28b6.svg";